import type { LinkedAccount } from "@store/linkedAccountSlice";
import { TIKTOK_PLATFORM } from "@store/linkedAccountSlice";

export interface LinkedAccountDisplay {
  cornerBadgeLabel?: string;
  subtitle?: string;
  showRegionFlag: boolean;
  useStorePlaceholder: boolean;
}

const ACCOUNT_USER_TYPE_LABELS: Record<string, string> = {
  SELLER: "Seller",
  CREATOR: "Creator",
};

const ACCOUNT_TYPE_LABELS: Record<string, string> = {
  TIKTOK_SHOP_OFFICIAL_ACCOUNT: "Office Account",
  TIKTOK_MARKETING_ACCOUNT: "Marketing Account",
  TIKTOK_SHOP_CREATOR: "Creator Account",
};

const getTiktokAccountDisplay = (account: LinkedAccount): LinkedAccountDisplay => {
  const userType = account.accountUserType;
  const cornerBadgeLabel = userType ? (ACCOUNT_USER_TYPE_LABELS[userType] ?? userType) : undefined;

  let subtitle: string | undefined;
  if (userType === "SELLER") {
    subtitle = "Local";
  } else if (account.accountType) {
    subtitle = ACCOUNT_TYPE_LABELS[account.accountType] ?? account.accountType;
  }

  return {
    cornerBadgeLabel,
    subtitle,
    showRegionFlag: Boolean(account.region),
    useStorePlaceholder: userType === "SELLER" && !account.accountImage,
  };
};

const getDefaultAccountDisplay = (account: LinkedAccount): LinkedAccountDisplay => ({
  subtitle: account.accountType,
  showRegionFlag: Boolean(account.region),
  useStorePlaceholder: !account.accountImage,
});

export const getAccountDisplay = (account: LinkedAccount): LinkedAccountDisplay => {
  const platform = account.platform ?? TIKTOK_PLATFORM;
  if (platform === TIKTOK_PLATFORM) {
    return getTiktokAccountDisplay(account);
  }
  return getDefaultAccountDisplay(account);
};
